import { PaletteOptions } from "@mui/material/styles/createPalette";

const palette: PaletteOptions = {
  primary: {
    main: "#bda082",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "rgb(168, 85, 63)",
  },
  text: {
    primary: "#000000",
    secondary: "#636363",
  },
};

export default palette;
